"use strict";

exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireWildcard(require("react"));

var _Config = require("base-shell/lib/providers/Config");

var _notistack = require("notistack");

var _reactIntl = require("react-intl");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var runUpdate = function runUpdate() {
  window.update && window.update();
};

function _default(_ref) {
  var children = _ref.children;
  var intl = (0, _reactIntl.useIntl)();

  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  var _ref2 = appConfig || {},
      update = _ref2.update;

  var _ref3 = update || {},
      _ref3$checkInterval = _ref3.checkInterval,
      checkInterval = _ref3$checkInterval === void 0 ? 3000 : _ref3$checkInterval,
      _ref3$repeatInterval = _ref3.repeatInterval,
      repeatInterval = _ref3$repeatInterval === void 0 ? 300000 : _ref3$repeatInterval;

  var action = function action(key) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "contained",
      style: {
        margin: 8
      },
      onClick: function onClick() {
        closeSnackbar(key);
        runUpdate();
      }
    }, intl.formatMessage({
      id: 'update',
      defaultMessage: 'Update'
    })), /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      onClick: function onClick() {
        setTimeout(checkUpdate, repeatInterval);
        closeSnackbar(key);
      }
    }, intl.formatMessage({
      id: 'later',
      defaultMessage: 'Later'
    })));
  };

  var showUpdateToast = function showUpdateToast() {
    enqueueSnackbar(intl.formatMessage({
      id: 'update_available',
      defaultMessage: 'Update available!'
    }), {
      persist: true,
      action: action,
      preventDuplicate: true,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    });
  };

  var checkUpdate = function checkUpdate() {
    if (window.update) {
      showUpdateToast();
    } else {
      setTimeout(checkUpdate, checkInterval);
    }
  };

  (0, _react.useEffect)(checkUpdate, [checkUpdate]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
}

module.exports = exports.default;